import styled from '@emotion/styled'

interface Props {
  variant?: 'label2' | 'labelSmall' | 'h4'
  disabled?: boolean
}

const InputLabel = styled.label<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    display: 'inline-block',
    color: theme.colors.primary,
    fontFamily: theme.fonts.families.label,
    fontSize: '22px',
    fontWeight: 'bold',
    letterSpacing: '0.55px',
    lineHeight: '26px',
    marginBottom: '0.8em',
  }),
  ({ variant, theme }) =>
    variant === 'label2' && {
      fontSize: '14px',
      letterSpacing: '0.35px',
      lineHeight: '18px',
      color: theme.colors.primary,
    },
  ({ variant, theme }) =>
    variant === 'h4' && {
      fontFamily: theme.fonts.families.headline,
      fontSize: '12px',
      fontWeight: 'bold',
      lineHeight: '16px',
      letterSpacing: '0.6px',
    },
  ({ variant, theme }) =>
    variant === 'labelSmall' && {
      fontSize: '10px',
      color: theme.colors.textMuted,
      marginBottom: '0.1em',
    },
  ({ theme, disabled }) =>
    !!disabled && {
      color: theme.colors.textMuted,
    }
)

export const InputLabelMT0 = styled(InputLabel)(() => ({
  marginTop: '0px',
}))

export default InputLabel
